import { http } from './http'
import { auth } from './auth'
import { z } from 'zod'
import { AgendaColumnEntrySchema } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'

export const agendaColumnEntries = {
  createEntry: async ({
    payload,
    dealId,
  }: {
    payload: {
      agenda_column_entry: {
        agenda_column_id: string
        agenda_object_id: string
        value: string
      }
    }
    dealId: number
  }) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/agenda_column_entries`, payload, dealId)
    const parsedResult = parseWithZod(
      z.object({ agenda_column_entry: AgendaColumnEntrySchema }),
      result,
    )
    return parsedResult.agenda_column_entry
  },

  updateValue: async ({
    id,
    payload,
    dealId,
  }: {
    id: number
    payload: { value: string }
    dealId: number
  }) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/agenda_column_entries/${id}/update_value`,
      payload,
      dealId,
    )
    const parsedResult = parseWithZod(
      z.object({ agenda_column_entry: AgendaColumnEntrySchema }),
      result,
    )
    return parsedResult.agenda_column_entry
  },

  deleteEntry: async ({ id, dealId }: { id: number; dealId: number }) => {
    const regionHost = auth.getUserRegionHost()
    await http.delete(`${regionHost}/api/agenda_column_entries/${id}`, dealId)
  },
}
